import axios from 'axios'
import qs from 'qs'
// import serverConfig from 'serverConfig'
import { Message } from 'iview'
import serverConfig from './serverConfig'
axios.defaults.withCredentials = true
axios.defaults.retry = 6

switch (process.env.BUILD_ENV) {
  case 'production':
    axios.defaults.baseURL = serverConfig.formalServer
    break
  case 'testing':
    axios.defaults.baseURL = serverConfig.testServer
    break
  default:
    axios.defaults.baseURL = '/web'
}

axios.interceptors.request.use(config => {
  // loading
  return config
}, error => {
  return Promise.reject(error)
})

// // http request 拦截器
// axios.interceptors.request.use(config => {
//   if (config.method === 'post') {
//     config.cancelToken = new CancelToken(c => {
//       removePending(config, c)
//     })
//   }
//   return config
// }, err => {
//   return Promise.reject(err)
// })
// // http response 拦截器
// axios.interceptors.response.use(response => {
//   if (response.config.method === 'post') {
//     removePending(response.config)
//   }
//   return response
// }, error => {
//   pending = []
//   return {
//     data: {
//       error: error
//     }
//   }
// })

// function checkStatus(response) {
//   // loading
//   // 如果http状态码正常，则直接返回数据
//   if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
//     return response
//     // 如果不需要除了data之外的数据，可以直接 return response.data
//   }
//   // 异常状态下，把错误信息返回去
//   return {
//     status: -404,
//     msg: '网络异常'
//   }
// }

function getWebRequestUrl () {
  let addr = window.location.href
  return addr.split('#')[1]
}
export default {
  get (url, params, notConvert) {
    let requestUrl = url
    // if (process.env.BUILD_ENV === 'formal') {
    //   requestUrl = requestUrl.replace('/web', '')
    // }
    if (notConvert) {
      return axios({
        method: 'get',
        url: requestUrl,
        timeout: 200000,
        headers: {
          'X-Requested-uri': getWebRequestUrl(),
          'Access-Control-Allow-Origin': '*'
        }
      })
    } else {
      let newData = params
      // if (sessionStorage.getItem('token')) {
      //   Object.assign(newData, {
      //     '_sid_token_': sessionStorage.getItem('token'),
      //     timestamp: (new Date()).valueOf()
      //   })
      // }
      return axios({
        method: 'get',
        url: requestUrl,
        params: newData, // get 请求时带的参数
        timeout: 200000
        // headers: {
        //   'X-Requested-With': 'XMLHttpRequest'
        // }
      }).then(
        (res) => {
          return res
        }
      )
    }
  },
  post (url, data) {
    let newData = data || {}
    let requestUrl = url
    // if (process.env.BUILD_ENV === 'formal') {
    //   requestUrl = requestUrl.replace('/web', '')
    // }
    Object.keys(newData).map(item => {
      if (typeof newData[item] === 'string') {
        newData[item] = newData[item].replace(/(^\s*)|(\s*$)/g, '')
      }
    })
    return axios({
      method: 'post',
      url: requestUrl,
      data: qs.stringify(newData),
      timeout: 200000,
      headers: {
        'X-Requested-uri': getWebRequestUrl(),
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }).then(
      (res) => {
        return res
      }
    ).catch(err => {
      console.log(err)
      Message.error('操作错误')
      // return {
      //   data: {
      //     resultCode: '5000',
      //     resultMsg: '操作错误'
      //   }
      // }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js